import { Column, Entity, Index, JoinColumn, ManyToOne } from 'typeorm';
import { BaseEntity } from './base.entity';
import { EmailRecordEntity } from './email-record.entity';
import { UserEntity } from './user.entity';

@Entity('email_record_sharing_override')
@Index(['emailRecordId'], { unique: true })
export class EmailRecordSharingOverrideEntity extends BaseEntity {
	@Column({
		name: 'fk_email_record__id',
		type: 'bigint',
		unsigned: true,
	})
	public emailRecordId!: string;

	@ManyToOne(() => EmailRecordEntity, { onDelete: 'CASCADE' })
	@JoinColumn({ name: 'fk_email_record__id' })
	public emailRecord!: EmailRecordEntity;

	@Column({ name: 'is_shared', type: 'boolean' })
	public isShared!: boolean;

	@Column({
		name: 'set_by_user_id',
		type: 'int',
		unsigned: true,
	})
	public setByUserId!: number;

	@ManyToOne(() => UserEntity)
	@JoinColumn({ name: 'set_by_user_id' })
	public setByUser!: UserEntity;
}
